import { computed, type ComputedRef, type Ref } from 'vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { DESKTOP_MEDIA_QUERY, useMediaQuery } from '@/hooks/useMediaQuery'

/** Ponto de corte único (spec D5): abaixo de 768px é celular. */
export const DESKTOP_MIN_QUERY = DESKTOP_MEDIA_QUERY
/** Celular deitado: passa de 768px de largura, mas é baixo. */
export const LANDSCAPE_PHONE_QUERY = '(orientation: landscape) and (max-height: 500px)'

export function useIsMobile(): {
  isMobile: ComputedRef<boolean>
  isLandscapePhone: Ref<boolean>
  isMobileLayout: ComputedRef<boolean>
} {
  const { flags } = useFeatureFlags()
  // Sem matchMedia (jsdom) o fallback `true` descreve o desktop.
  const isDesktopWidth = useMediaQuery(DESKTOP_MIN_QUERY)
  const isMobile = computed(() => !isDesktopWidth.value)
  const isLandscapePhone = useMediaQuery(LANDSCAPE_PHONE_QUERY, false)
  const isMobileLayout = computed(
    () => flags.enabledDashboardMobile && (isMobile.value || isLandscapePhone.value)
  )
  return { isMobile, isLandscapePhone, isMobileLayout }
}
